<template>
  <div class="homepage-container homepage-v1">


    <!-- Ready to Enter Section -->
    <section class="ready-to-enter-section">
      <!-- Desktop Decorative Triangle Background Patterns on sides -->
      <div class="triangles-side left-side d-none d-lg-flex animate-slide-left">
        <img :src="$t('Home.ClaimYourOfferDesktopImg')" alt="Decorative Pattern" />
      </div>

      <div class="container py-5 position-relative" style="z-index: 2;">
        <div class="row justify-content-center">
          <div class="col-lg-8 text-center promo-header-block animate-fade-in">
            <h2 class="promo-title" v-html="$t('Home.V1BannerTitle')"></h2>
            <p class="promo-desc" v-html="$t('Home.V1BannerDesc')"></p>
          </div>
        </div>

        <div class="row justify-content-center mt-4">
          <div class="col-lg-6 text-center ready-block animate-fade-in delay-1">
            <h3 class="ready-title">{{ $t('Home.ClaimYourOfferTitle') }}</h3>
            
            <div class="btn-container mt-4">
              <router-link to="/SignIn" class="btn btn-get-started text-uppercase">
                {{ $t('Home.GetStartedBtn') }}
              </router-link>
            </div>
            
            <p class="faq-link-item mt-4">
              {{ $t('Home.TroubleParticipating') }} 
              <router-link to="/FAQ" class="accent-link">{{ $t('Home.FAQsText') }}</router-link>
            </p>
          </div>
        </div>
      </div>

      <div class="triangles-side right-side d-none d-lg-flex animate-slide-right">
        <img :src="$t('Home.ClaimYourOfferDesktopImg')" alt="Decorative Pattern" class="flip-horizontal" />
      </div>
    </section>

    <!-- How to Participate Section -->
    <section class="how-to-participate-section" :style="{ '--htw-bg-desktop': 'url(' + $t('Home.HtwBgDesktop') + ')', '--htw-bg-mobile': 'url(' + $t('Home.HtwBgMobile') + ')' }">
      <div class="container py-2">
        <h2 class="section-title text-center animate-fade-in">{{ $t('Home.HtwTitleDesktop') }}</h2>
        
        <div class="row justify-content-center htw-cards-grid">
          <!-- Card 1: Enter Now -->
          <div class="col-md-6 mb-4 animate-card-1">
            <div class="htw-card">
              <div class="card-icon-container">
                <!-- Shield Check icon -->
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#2584C5" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shield"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><polyline points="9 11 11 13 15 9"></polyline></svg>
              </div>
              <h3 class="card-title">{{ $t('Home.HtwV1Step1Title') }}</h3>
              <p class="card-desc">{{ $t('Home.HtwV1Step1Desc') }}</p>
            </div>
          </div>

          <!-- Card 2: You Could Win -->
          <div class="col-md-6 mb-4 animate-card-2">
            <div class="htw-card">
              <div class="card-icon-container">
                <!-- Trophy icon -->
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#2584C5" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-award"><circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline></svg>
              </div>
              <h3 class="card-title">{{ $t('Home.HtwV1Step2Title') }}</h3>
              <p class="card-desc">{{ $t('Home.HtwV1Step2Desc') }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HomePageV1',
  props: {
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
  },
};
</script>

<style scoped>
/* Page Layout */
.homepage-container {
  overflow-x: hidden;
}



/* Ready to Enter Section */
.ready-to-enter-section {
  padding: 4.5rem 0;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
}

.triangles-side {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  max-width: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  opacity: 0.85;
}

.left-side {
  left: 0;
}

.right-side {
  right: 0;
}

.flip-horizontal {
  transform: scaleX(-1);
}

.promo-title {
  font-size: 2.85rem;
  font-weight: 700;
  line-height: 1.25;
  color: #000000;
  margin-bottom: 1.5rem;
  font-family: 'Outfit', 'Inter', sans-serif;
}

:deep(.text-primary) {
  color: #2584C5 !important;
}

.promo-desc {
  font-size: 1.15rem;
  line-height: 1.75;
  color: #4b5563;
  margin-bottom: 2rem;
}

.ready-title {
  font-size: 2.25rem;
  font-weight: 700;
  color: #000000;
  margin-bottom: 1.5rem;
}

.btn-get-started {
  display: inline-block;
  background-color: #2584C5;
  color: #ffffff !important;
  font-size: 1.2rem;
  font-weight: 700;
  padding: 0.85rem 5rem;
  border-radius: 6px;
  text-decoration: none;
  box-shadow: 0 4px 12px rgba(37, 132, 197, 0.25);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border: none;
  text-align: center;
  width: 100%;
  max-width: 340px;
}

.btn-get-started:hover {
  background-color: #1b6ca2;
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(37, 132, 197, 0.4);
  text-decoration: none !important;
}

.btn-get-started:active {
  transform: translateY(0);
}

.faq-link-item {
  font-size: 0.95rem;
  color: #6b7280;
}

.accent-link {
  color: #2584C5 !important;
  text-decoration: underline !important;
  font-weight: 600;
}

.accent-link:hover {
  color: #1b6ca2 !important;
}

/* How to Participate Section */
.how-to-participate-section {
  background-image: var(--htw-bg-desktop);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  padding: 6.5rem 0;
  position: relative;
  background-color: #07213e;
}

.section-title {
  font-size: 2.75rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 4rem;
  font-family: 'Outfit', 'Inter', sans-serif;
}

.htw-cards-grid {
  max-width: 980px;
  margin: 0 auto;
}

/* Glassmorphism Cards */
.htw-card {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  padding: 3rem 2.5rem;
  color: #ffffff;
  min-height: 280px;
  backdrop-filter: blur(12px);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.2);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  display: flex;
  flex-direction: column;
}

.card-icon-container {
  background: #ffffff;
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.card-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #ffffff;
  font-family: 'Outfit', 'Inter', sans-serif;
}

.card-desc {
  font-size: 1rem;
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 0;
}

/* Hover effects */
.htw-card:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
}

.htw-card:hover .card-icon-container {
  background: rgba(37, 132, 197, 0.1);
  stroke: #ffffff;
}

.htw-card:hover .card-icon-container svg {
  stroke: #ffffff;
}

/* Animations */
.animate-fade-in {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeIn 0.8s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
}



.delay-1 {
  animation-delay: 0.2s;
}

.animate-slide-left {
  opacity: 0;
  transform: translateY(-50%) translateX(-30px);
  animation: slideLeft 0.8s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
  animation-delay: 0.3s;
}

.animate-slide-right {
  opacity: 0;
  transform: translateY(-50%) translateX(30px);
  animation: slideRight 0.8s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
  animation-delay: 0.3s;
}

.animate-card-1 {
  opacity: 0;
  transform: translateY(30px);
  animation: fadeIn 0.8s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
  animation-delay: 0.4s;
}

.animate-card-2 {
  opacity: 0;
  transform: translateY(30px);
  animation: fadeIn 0.8s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
  animation-delay: 0.6s;
}

@keyframes fadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}



@keyframes slideLeft {
  to {
    opacity: 0.85;
    transform: translateY(-50%) translateX(0);
  }
}

@keyframes slideRight {
  to {
    opacity: 0.85;
    transform: translateY(-50%) translateX(0);
  }
}

/* Responsive styles */
@media screen and (max-width: 1199px) {
  .promo-title {
    font-size: 2.35rem;
  }
  .ready-title {
    font-size: 2rem;
  }
  .triangles-side {
    max-width: 140px;
  }
}

@media screen and (max-width: 991px) {
  .ready-to-enter-section {
    padding: 3.5rem 0;
  }
  .how-to-participate-section {
    padding: 5rem 0;
  }
  .section-title {
    font-size: 2.25rem;
    margin-bottom: 3rem;
  }
}

@media screen and (max-width: 767px) {
  .promo-title {
    font-size: 1.85rem;
  }
  .promo-desc {
    font-size: 1rem;
  }
  .ready-title {
    font-size: 1.65rem;
  }
  .btn-get-started {
    max-width: 100%;
    padding: 0.85rem 3rem;
    font-size: 1.1rem;
  }
  .how-to-participate-section {
    background-image: var(--htw-bg-mobile);
    padding: 4rem 0;
  }
  .section-title {
    font-size: 1.85rem;
    margin-bottom: 2.5rem;
  }
  .htw-card {
    padding: 2.5rem 2rem;
    min-height: auto;
  }
}
</style>

